module.exports = __webpack_public_path__ + "img/suit-front.84ee7692.png";